module.exports = __webpack_public_path__ + "static/img/scene5.b6c57f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene5.png
// module id = jWXu
// module chunks = 1